import React from "react";
import Util from "../../global/utils/Helpers";
import "./FEINValidation.css";

class FEINValidation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validFEIN: undefined,
      fein: undefined,
    };
  }

  fetchValidFEIN = (fein) => {
    let apiIndex = Util.isLocalhost()
      ? `http://localhost:3214/reference/fein?fein=${fein}`
      : `${Util.getCurrentHost()}/auth/auth/reference/fein?fein=${fein}`;
    fetch(apiIndex, {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          window.btoa("flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1"),
      },
    })
      .then((response) => response.json())
      .then((data) => this.setState({ validFEIN: data.is_valid }))
      .catch((error) => console.log(error));
  };

  render() {
    const { formApi, machine_name } = this.props;
    if (formApi) {
      let fein =
        formApi.getState().values && formApi.getState().values[machine_name];
      if (fein !== this.state.fein) {
        this.setState({ fein: fein });
        if (fein && fein.length === 10 && this.state.validFEIN === undefined) {
          this.fetchValidFEIN(fein);
        } else {
          if (this.state.validFEIN !== undefined) {
            this.setState({ validFEIN: undefined });
          }
        }
      }
    }
    return this.state.validFEIN === false ? (
      <div className={"fein-warning"}>
        <p>
          WARNING: The Federal Employer Identification Number (FEIN) entered on
          this application cannot be verified as obviously accurate by the FLAG
          System. To avoid a denial of your application, first check to make
          sure you entered the correct 9-digit FEIN and then allow the FLAG
          System to re-verify the FEIN. If the FLAG System continues to notify
          you that the FEIN cannot be verified as obviously accurate, you should
          immediately contact the OFLC National Processing Center to
          request and obtain a FEIN verification before this application and any
          subsequent applications using this same FEIN are submitted for
          processing. To request a verification of the FEIN, please send
          official documentation clearly evidencing the validity of the FEIN
          using one of the following means:
        </p>
        <p>
          E-Mail (recommended): OFLC.LCA@dol.gov and write "LCA Business
          Validation Team" in the subject line of the e-mail.
        </p>
        <p>
          Mail: U.S. Department of Labor, Employment and Training
          Administration, Office of Foreign Labor Certification,
          200 Constitution Avenue NW, Room N-5311
          Washington, DC 20210. Attn: LCA Business Verification Team
        </p>
        <p>
          Examples of official documentation evidencing the validity of the FEIN
          include the following: Internal Revenue Service documentation noting
          the assigned FEIN; a Federal and/or State tax return with a
          pre-printed label or coupon; documentation from the employer's
          financial institution; article of incorporation / business license or
          other certifications of business existence; Secretary of
          State/Corporation Commission registration documents; or other official
          government documents evidencing the FEIN.
        </p>
      </div>
    ) : null;
  }
}

export default FEINValidation;
